import { render } from "./ApiKey.vue?vue&type=template&id=edd9319a&scoped=true"
import script from "./ApiKey.vue?vue&type=script&lang=js"
export * from "./ApiKey.vue?vue&type=script&lang=js"

import "./ApiKey.vue?vue&type=style&index=0&id=edd9319a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd9319a"]])

export default __exports__